import { googleSheetRef } from '@iotv/iotv-v3-types'
import { ObjectHistory } from './ObjectHistory'
import { HistoryStore } from './HistoryStore'

const typeName = 'ObservationHistory'

export interface IObservationHistory {
  observedHistory: HistoryStore
  googleSheet?: googleSheetRef
}

export class ObservationHistory extends ObjectHistory implements IObservationHistory {
  constructor(ob: Partial<IObservationHistory>) {
    super({
      type: typeName,
    })
    this.observedHistory = new HistoryStore(
      ob.observedHistory ?? {
        systemProperties: {
          autoTrim: false,
          maxAgeMS: undefined,
          maxLength: undefined,
        },
      },
    )
    this.googleSheet = ob.googleSheet
  }
  observedHistory: HistoryStore
  googleSheet?: googleSheetRef | undefined
}
